export default __webpack_public_path__ + "static/media/error.8df2352c.svg";